// removed by extract-text-webpack-plugin
module.exports = {"container":"application_container_1Otxju_-SI"};


//////////////////
// WEBPACK FOOTER
// ./Application/application.css
// module id = 494
// module chunks = 0